<template>
  <div class="flex list-add-works-item justify-between">
    <div class="image-info flex justify-between">
      <div
        class="polish__image mr-2"
        :style="{backgroundImage: `url(${work.image})`}"
        v-if="work.type == 'polish'&&work.image"
      >
      </div>
      <div
        v-else
        class="font-bold text-sm mr-2"
      >{{ index + 1 }}.</div>
      <div class="info">
        <div class="name font-bold text-sm">
          {{ work.name }}
        </div>
        <div class="description text-xs">
          {{ work.description }}
        </div>
        <div class="price flex items-center gap-2">
          <span class="font-bold text-sm">{{ $toCurrency(work.price) }}</span>
          <span class="font-bold text-sm cost-value">{{ $toCurrency(work.cost) }}</span>
        </div>
      </div>
    </div>

    <div class="remove ml-2">
      <button
        class="check focus:outline-none"
        @click="
          $store.dispatch('additionalWorks/remove', work.additional_work_id)
        "
      >
        <i class="fas fa-times text-red-500"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    work: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
};
</script>
<style scoped>
.polish__image {
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  text-align: right;
  padding: 1px;
}
</style>
